import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 mb-3" }, "Platební instrukce", -1)
const _hoisted_2 = { class: "mt-1 fw-bold" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, "Datum vystavení: " + _toDisplayString(_ctx.invoice.issueDate), 1),
    _createElementVNode("div", _hoisted_2, "Datum splatnosti: " + _toDisplayString(_ctx.invoice.dueDate), 1),
    _createElementVNode("div", _hoisted_3, "Způsob platby: " + _toDisplayString(_ctx.invoice.paymentType), 1),
    (_ctx.invoice.paymentType === 'Převodem')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "Bankovní účet: " + _toDisplayString(_ctx.supplier?.bankAccount), 1),
          _createElementVNode("div", _hoisted_6, "Variabilní symbol: " + _toDisplayString(_ctx.invoice.variableSymbol), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}